import request from '@helpers/request';
import { API_HOST_NAME, API_PAYSLIP_PATH } from '../../env';

export const getPayslipYearsListService = ({ isHousehold }) =>
  request(`${API_HOST_NAME}${API_PAYSLIP_PATH}/valid-years`, {
    method: 'GET',
    params: {
      isHousehold,
    },
  });

export const getPayslipOverviewService = ({ year, isHousehold }) =>
  request(`${API_HOST_NAME}${API_PAYSLIP_PATH}/summary`, {
    method: 'GET',
    params: {
      isHousehold,
      year,
    },
  });

export const getPayslipDetailService = ({ paidDate, type }) =>
  request(`${API_HOST_NAME}${API_PAYSLIP_PATH}/detail`, {
    method: 'GET',
    params: {
      type,
      paidDate,
    },
  });

export const exportPayslipDetailService = ({ paidDate, type }) =>
  request(`${API_HOST_NAME}${API_PAYSLIP_PATH}/export`, {
    method: 'GET',
    params: {
      type,
      paidDate,
    },
  });
